// Modules
import React from 'react';
import SingleMatchHistory from './singleMatchHistory';

export default function GameScorecard(props){
    return(
        <div id="match-scorecard" className="hideOverflow">
            <div className="scrollY">
                <SingleMatchHistory/>
            </div>
        </div>
    );
}


// WEBPACK FOOTER //
// ./src/comps/gameScorecard.js